import { Flex, Text } from "rebass/styled-components";
import styled from "styled-components";
import { MdCheckCircle } from "react-icons/md";

import { AnimatedTooltip } from "MVVM/Components/AnimatedTooltip";

interface DeveloperPillProps {
  developerName: string;
}

export const DeveloperPill = ({ developerName }: DeveloperPillProps) => {
  return (
    <AnimatedTooltip
      content={`This clip was saved by our partner ${developerName}. It did not count towards your clip limit and does not count towards your storage limit.`}
      position="bottom"
      maxWidth={280}
    >
      <PillContainer>
        <PillLeft>
          <MdCheckCircle size={15} />
          <PillText>
            This clip was generated and saved by our partner {developerName}
          </PillText>
        </PillLeft>
      </PillContainer>
    </AnimatedTooltip>
  );
};

const PillContainer = styled(Flex)`
  align-items: center;
  background: ${({ theme }) => `${theme.colors.envy}10`};
  border-bottom: 1px solid ${({ theme }) => `${theme.colors.envy}30`};
  justify-content: space-between;
  padding: 10px 16px;
  width: 100%;
`;

const PillLeft = styled(Flex)`
  align-items: center;
  color: ${({ theme }) => theme.colors.envy};
  gap: 6px;
`;

const PillText = styled(Text)`
  color: ${({ theme }) => theme.colors.envy};
  font-family: Barlow;
  font-size: 13px;
  font-weight: 600;
`;
